// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","logo":"App_logo__1ItuU","header":"App_header__3ZZ1n"};